(() => {
  if (window.fpHomeWaxyFilmReady) return;
  window.fpHomeWaxyFilmReady = true;

  const setup = (root) => {
    if (root.dataset.waxyFilmReady === 'true') return;
    const video = root.querySelector('video');
    const button = root.querySelector('[data-waxy-film-toggle]');
    const label = button?.querySelector('[data-waxy-film-label]');
    const symbol = button?.querySelector('[data-waxy-film-symbol]');
    if (!video || !button || !label || !symbol) return;

    const controller = new AbortController();
    const options = { signal: controller.signal };
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    let observer;
    let inView = !('IntersectionObserver' in window);
    let userPaused = false;
    let ended = false;
    let failed = false;
    let wanted = false;
    let pending = false;
    let disposed = false;
    let chosenSource = '';
    let request = 0;

    root.dataset.waxyFilmReady = 'true';
    video.muted = true;
    video.controls = false;
    button.hidden = false;

    const savingData = () => Boolean(connection && (connection.saveData || /^(slow-)?2g$/.test(connection.effectiveType || '')));
    const sync = () => {
      const playing = !video.paused && !video.ended;
      label.textContent = playing ? button.dataset.pauseLabel : ended ? button.dataset.replayLabel : button.dataset.playLabel;
      symbol.textContent = playing ? 'Ⅱ' : '▶';
      button.setAttribute('aria-pressed', String(playing));
    };
    const pause = () => {
      wanted = false;
      pending = false;
      request += 1;
      video.pause();
      sync();
    };
    const mayAutoPlay = () => !disposed && !document.hidden && inView && !motion.matches && !savingData() && !userPaused && !ended && !failed;
    const start = async (manual = false) => {
      if (disposed || pending || document.hidden || (!manual && !mayAutoPlay())) return;
      if (!chosenSource) {
        const mobile = window.matchMedia('(max-width: 760px)').matches;
        chosenSource = mobile ? video.dataset.mobileSrc : video.dataset.desktopSrc;
      }
      if (!chosenSource) return;
      if (manual) {
        userPaused = false;
        failed = false;
        if (ended) video.currentTime = 0;
        ended = false;
      }
      if (!video.getAttribute('src')) {
        video.src = chosenSource;
        video.load();
      }
      video.muted = true;
      wanted = true;
      pending = true;
      const current = ++request;
      try {
        await video.play();
        if (disposed || !wanted || document.hidden) video.pause();
      } catch (_) {
        if (current === request) {
          wanted = false;
          failed = true;
        }
      } finally {
        if (current === request) pending = false;
        if (!disposed) sync();
      }
    };

    button.addEventListener('click', () => {
      if (pending || (!video.paused && !video.ended)) {
        userPaused = true;
        pause();
      } else start(true);
    }, options);
    video.addEventListener('play', sync, options);
    video.addEventListener('pause', sync, options);
    video.addEventListener('ended', () => {
      ended = true;
      wanted = false;
      pending = false;
      sync();
    }, options);
    video.addEventListener('error', () => {
      failed = true;
      pause();
      video.removeAttribute('src');
      video.load();
    }, options);

    const onPolicyChange = () => {
      if (motion.matches || savingData()) pause();
      else if (mayAutoPlay()) start();
    };
    motion.addEventListener('change', onPolicyChange, options);
    connection?.addEventListener?.('change', onPolicyChange, options);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) pause();
      else if (mayAutoPlay()) start();
    }, options);
    window.addEventListener('pagehide', pause, options);
    window.addEventListener('pageshow', () => { if (mayAutoPlay()) start(); }, options);

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(([entry]) => {
        inView = Boolean(entry?.isIntersecting);
        if (!inView) pause();
        else if (mayAutoPlay()) start();
      }, { threshold: 0.15 });
      observer.observe(video);
    } else if (mayAutoPlay()) start();

    root._fpWaxyFilmCleanup = () => {
      disposed = true;
      pause();
      controller.abort();
      observer?.disconnect();
      delete root.dataset.waxyFilmReady;
    };
    sync();
  };
  const rootsWithin = (scope) => [
    ...(scope.matches?.('[data-fph-waxy-film]') ? [scope] : []),
    ...scope.querySelectorAll('[data-fph-waxy-film]')
  ];
  const init = (scope) => rootsWithin(scope).forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => rootsWithin(event.target).forEach(root => root._fpWaxyFilmCleanup?.()));
})();
